import angular from 'angular';
import routers from './routers.js';
import imageManagementCtrl from './imageManagementCtrl';

export default angular
  .module('input.electronImage.imageManagement', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config);
      });
    },
  ])
  .controller('imageManagementCtrl', imageManagementCtrl).name;



// WEBPACK FOOTER //
// ./src/app/input/electronImage/imageManagement/index.js